// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
  min-width: 80%;
  height: 80%;
}
.kt-demo-icon .kt-demo-icon__preview i {
  font-size: 1.5rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/components-prewiew/components-prewiew.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[".modal-dialog {\r\n  min-width: 80%;\r\n  height: 80%;\r\n}\r\n.kt-demo-icon .kt-demo-icon__preview i {\r\n  font-size: 1.5rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
